export const states = {
  addTask: 'addTask',
  editTask: 'editTask',
  viewTasks: 'viewTasks',
};
